import { useEffect, useState } from "react";
import ArenaBackground from "../assets/arena-bg.png";
import { alert } from 'react-custom-alert';




function Arena({ info, mintInfo, play, feed, clean, revive, mint, updateFrenNumber, getAllFrens, getSupply, getCost}) {
  const [players, setPlayers] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isOpenLeaderboard, setIsOpenLeaderBoard] = useState(false);
  const [isOpenMyFrenPlayerCard, setIsOpenMyFrenPlayerCard] = useState(false);
  const [isOpenAllFrenPlayerCard, setIsOpenAllFrenPlayerCard] = useState(false);
  const [isOpenDeadPlayerCard, setIsOpenDeadPlayerCard] = useState(false);
  const [aliveFrens, setAliveFrens] = useState([]);
  const [deadFrens, setDeadFrens] = useState([]);
  const [ownedByUser, setOwnedByUser] = useState([]);

  const [selectedAllFren, setSelectedAllFren] = useState();
  const [selectedMyFren, setSelectedMyFren] = useState();
  const [selectedDead, setSelectedDead] = useState();

  const [currentLoadedFren, setCurrentLoadedFren] = useState(1);

  const [refresh, setRefresh] = useState(false);


  // const getDataNew = async () => {
  //   setLoading(true);
  //   const aliveFrens = [];
  //   const deadFrens = [];
  //   const ownedByUser = [];
  //   const players = [];

  //   const batchSize = 1;
  //   const promises = [];
  //   for (let i = 1; i <= mintInfo.supply; i += batchSize) {
  //     const batchPromises = [];
  //     for (let j = i; j < i + batchSize && j <= mintInfo.supply; j++) {
  //       batchPromises.push(
  //         Promise.all([
  //           info.contract.methods.tokenURI(j).call(),
  //           info.contract.methods.isAlive(j).call(),
  //           info.contract.methods.ownerOf(j).call(),
  //           info.contract.methods.getPlayerByIndex(j).call(),
  //         ])
  //       );
  //     }
  //     promises.push(Promise.all(batchPromises));
  //     console.log("Hello ARR: ", i);
  //   }
  //   const results = await Promise.all(promises);
  //   for (let i = 0; i < results.length; i++) {
  //     for (let j = 0; j < results[i].length; j++) {
  //       const [data, isAlive, owner, player] = results[i][j];
  //       if (data && isAlive !== undefined && owner && player) {
  //         const json = atob(data.substring(29));
  //         const result = JSON.parse(json);
  //         if (isAlive) {
  //           aliveFrens.push(result);
  //         } else {
  //           deadFrens.push(result);
  //         }
  //         players.push(player);
  //         if (owner.toLowerCase() == info.account) {
  //           ownedByUser.push(result);
  //         }
  //       }
  //     }
  //     console.log("Hello: ", i);
  //   }
  // }

  const getData = async () => {
    setLoading(true);
    const aliveFrens = [];
    const deadFrens = [];
    const ownedByUser = [];
    // const players = [];
    for (let i = 1; i <= mintInfo.supply; i++) {

      // console.time('checkTime')
    try {
      const [data, isAlive, owner] = await Promise.all([
        info.contract.methods.tokenURI(i).call(),
        info.contract.methods.isAlive(i).call(),
        info.contract.methods.ownerOf(i).call(),
        // info.contract.methods.getPlayerByIndex(i).call(),
      ]);
      const json = atob(data.substring(29));
      const result = JSON.parse(json);

      if (isAlive) {
        aliveFrens.push(result);
      } else {
        deadFrens.push(result);
      }
      // players.push(player);
      
      //check if connected users is the owner of the token and add it to the array
      if (owner.toLowerCase() == info.account) {
        ownedByUser.push(result);
      }
    }catch (error) {
      console.log("Error 20: ",error);
      //try again
      try{
        const [data, isAlive, owner] = await Promise.all([
          info.contract.methods.tokenURI(i).call(),
          info.contract.methods.isAlive(i).call(),
          info.contract.methods.ownerOf(i).call(),
          // info.contract.methods.getPlayerByIndex(i).call(),
        ]);
        const json = atob(data.substring(29));
        const result = JSON.parse(json);
  
        if (isAlive) {
          aliveFrens.push(result);
        } else {
          deadFrens.push(result);
        }
        // players.push(player);
        
        //check if connected users is the owner of the token and add it to the array
        if (owner.toLowerCase() == info.account) {
          ownedByUser.push(result);
        }
      }catch{
        console.log("Error 20, 2: ",error);

      }
    }
    console.log("hey: ", i);
    setCurrentLoadedFren(i);

  }
    setAliveFrens(aliveFrens);
    setDeadFrens(deadFrens);
    setPlayers(players);
    setOwnedByUser(ownedByUser);
    setLoading(false);
    // console.timeEnd('checkTime')

}

  const chosenFren = (fren) => {
    setSelectedAllFren(fren);
    updateFrenNumber(fren.name.slice(fren.name.indexOf("#") + 1));

    setIsOpenLeaderBoard(false)
    setIsOpenMyFrenPlayerCard(false);
    setIsOpenDeadPlayerCard(false);
    setIsOpenAllFrenPlayerCard(true);
};
 const chosenDead = (fren) => {

    setSelectedDead(fren);
    updateFrenNumber(fren.name.slice(fren.name.indexOf("#") + 1));

    setIsOpenLeaderBoard(false)
    setIsOpenMyFrenPlayerCard(false);
    setIsOpenAllFrenPlayerCard(false);
    setIsOpenDeadPlayerCard(true);
};
 const chosenMyFren = (fren) => {

    setSelectedMyFren(fren);
    updateFrenNumber(fren.name.slice(fren.name.indexOf("#") + 1));

    setIsOpenLeaderBoard(false)
    setIsOpenAllFrenPlayerCard(false);
    setIsOpenDeadPlayerCard(false);
    setIsOpenMyFrenPlayerCard(true);
};

async function awaitForNBlocks(n) {  
  const currentBlockNumber = await info.web3.eth.getBlockNumber();
  console.log("Current block number: ", currentBlockNumber);
  const targetBlockNumber = currentBlockNumber + n;
  console.log("Target block number: ", targetBlockNumber);
  while (true) {
    const latestBlockNumber = await info.web3.eth.getBlockNumber();
    if (latestBlockNumber >= targetBlockNumber) {
      console.log("latestBlockNumber is: ", latestBlockNumber);
      break;
    }
    await new Promise(resolve => setTimeout(resolve, 3000)); // Wait for 1 second before checking again
  }
}

async function awaitforNSeconds(n) {
  console.log("Waiting for ", n, " seconds");
  await new Promise(resolve => setTimeout(resolve, n * 1000)); // Wait for n seconds
  console.log("Done waiting");
}

async function playNow() {
  try {
    await play();
    // await awaitForNBlocks(1);
    // await awaitforNSeconds(5);
    refreshSelectedFren(selectedMyFren)
  } catch (error) {
    console.error("error:", error);
  }
}

async function cleanNow() {
  try {
    await clean();
    // await awaitForNBlocks(1);
    // await awaitforNSeconds(5);
    refreshSelectedFren(selectedMyFren)
  } catch (error) {
    console.error("error:", error);
  }
}

async function feedNow() {
  try {
    await feed();
    // await awaitForNBlocks(1);
    // await awaitforNSeconds(5);
    refreshSelectedFren(selectedMyFren)
  } catch (error) {
    console.error("error:", error);
  }
}  

const getDataOfNewlyMintedFren = async(frenNumber) => {
  try {
    const [data, isAlive, owner, player] = await Promise.all([
      info.contract.methods.tokenURI(frenNumber).call(),
      info.contract.methods.isAlive(frenNumber).call(),
      info.contract.methods.ownerOf(frenNumber).call(),
      // info.contract.methods.getPlayerByIndex(frenNumber).call(),
    ]);
    const json = atob(data.substring(29));
    const result = JSON.parse(json);

    if (isAlive) {
      setAliveFrens([...aliveFrens, result]);
    } else {
      setDeadFrens([...deadFrens, result]);
    }
    console.log("data: ", data);
    // setPlayers([...players, player]);
    if (owner.toLowerCase() == info.account) {
      setOwnedByUser([...ownedByUser, result]);
    }
    setLoading(false);
    // console.timeEnd('checkTime')

  } catch (error) {
    console.error("error:", error);
  }
}

const mintNow = async() => {
  try {
    let numberOfFrens = mintInfo.supply;
    console.log("mintInfo.supply: ", numberOfFrens);
    await mint();
    // Add the new fren to the list of owned frens
    numberOfFrens++;
    console.log("mintInfo.supply: ", numberOfFrens);
    await getDataOfNewlyMintedFren(numberOfFrens);
    console.log("heyyyy: ");

  } catch (error) {
    console.error("error:", error);
  }
}


const refreshSelectedFren = async (fren) => {
  const [data, isAlive] = await Promise.all([
    info.contract.methods.tokenURI(fren.name.slice(fren.name.indexOf("#") + 1)).call(),
    info.contract.methods.isAlive(fren.name.slice(fren.name.indexOf("#") + 1)).call(),
  ]);
  const json = atob(data.substring(29));
  const result = JSON.parse(json);

  if (isAlive) {
    setSelectedMyFren(result);
  }
  else {
    setSelectedDead(result);
  }
  setRefresh(false);
}

const refreshFrenFunc = async (fren) => {
  if (!refresh) {
    console.log("refreshing fren: ", fren.name.slice(fren.name.indexOf("#") + 1));

    setRefresh(true);

    setTimeout(() => {
      setRefresh(false);
    }, 5000); // 5 seconds

    alert({ message: "Refreshing Fren Data...", type: 'success' })
    refreshSelectedFren(fren);
    chosenMyFren(fren);

  }else{
    alert({ message: "Already Refreshing Fren Data, please wait...", type: 'info' })
  }
}


const refreshFunc = async () => {
  if (!refresh) {
    setRefresh(true);

    setTimeout(() => {
      setRefresh(false);
    }, 5000); // 5 seconds

    alert({ message: "Refreshing Data...", type: 'success' })
    await getSupply();
    await getCost();
    await getData();

  }else{
    alert({ message: "Already Refreshing Data, please wait...", type: 'info' })
  }
}

  // useEffect(() => {
  //   info && info.contract && mintInfo && getData();
  // }, [info, mintInfo])

  // useEffect(() => {
  //   getData();
  // }, [mintInfo]);

  useEffect(() => {
    info && info.contract && mintInfo && getData();
  }, [info, mintInfo])



  return (
    <div style={{ position: "relative", backgroundImage: `url(${ArenaBackground})`, backgroundSize: "100% 100%", width: "1146px", height:"400px", display: "flex", flexDirection: "column", alignItems: "center", padding: "188px 0" , borderRadius:"50px", border:"10px solid black", paddingTop:"220px"}}>
        {/* <div style={{ fontSize: "40px", color: "white", letterSpacing:1.5, lineHeight: 1,  height:50}}>Game Overview</div> */}

                {/* Info about connected user starts here */}

                    {info.connected ? (
                        <span className="accountText" style={{fontSize: 15, color:"grey", position:"absolute", top: "5px", right: "26px"}}>
                        {String(info.account).substring(0, 6) +
                            "..." +
                            String(info.account).substring(38)}
                        </span>
                    ) : null}
                    <span style={{position: "absolute", color:"#1346d4", fontSize:16, top:"45px", right:"50px"}}>
                    {info.account ? "Connected" : "Connect Wallet"}
                    </span>

                    
                    <span style={{position: "absolute", color:"grey", fontSize:16, top:"30px", left:"50px"}}>
                      {info.account ?                 <button
                      disabled={!info.connected || mintInfo.cost == "0"}
                      className="refresh_button"
                      onClick={() => refreshFunc()}
                      >
                      Refresh All Frens
                      </button> : ""}
                    </span>

                      
                  {loading ? (
                        <span className="accountText" style={{fontSize: 18, color:"blue", position:"absolute", top: "30px", right: "500px"}}>
                        {"Loading... " +
                            String(currentLoadedFren) +
                            "/" +
                            String(mintInfo.supply)}
                        </span>
                    ) : null}

                    <span style={{position: "absolute", color:"grey", fontSize:16, top:"55px", left:"50px"}}>
                      {info.account ?                 <button
                      disabled={!info.connected || mintInfo.cost == "0"}
                      className="mint_button"
                      onClick={() => mintNow()}
                      >
                      Mint a new Fren
                      </button> : ""}
                    </span>
                {/* Info about connected user ends here */}


                {/* ************** All 3 sections starts here! ************** */}
                
    <div style={{ display: "grid", gridTemplateColumns: window.innerWidth < 891 ? "repeat(1, 10fr)" : "repeat(3, 10fr)", gridTemplateRows: "repeat(2, 1fr)",gridGap: 10 }}>      <div style={{ position: "relative", backgroundColor: "#e02b4f", width: "210px", height: "228px", marginTop: "50px", padding: "15px 40px", display: "flex", flexDirection: "column", alignItems: "center", borderRadius:"20px", border:"3px solid black" }}>
        <div style={{ fontSize: "20px", color: "white", letterSpacing:1.5, lineHeight: 1 , height:70}}>All Frens</div>
        {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "white" }}>Loading... <span style={{paddingLeft:3}}></span><div className="spinner-loader" style={{borderTop:"3px solid #800000"}}></div></div> :
          <div style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%", padding: "50px", width: "100%", height: "100%", maxHeight: "200px", overflow: "scroll" }}>
            {aliveFrens.map(fren => {
              return (<div key={fren.name} style={{ padding: "5px" }}>
                <img src={fren.image} alt={`fren`} style={{cursor: "pointer",width:40,height:43, borderRadius:3}} className="img-hover" onClick={() => chosenFren(fren)} />
              </div>);
            })}
          </div>}
      </div>
      <div style={{ position: "relative", backgroundColor: "#8a8ea1", width: "210px", height: "228px", marginTop: "50px", padding: "15px 40px", display: "flex", flexDirection: "column", alignItems: "center", borderRadius:"20px", border:"3px solid black" }}>
        <div style={{ fontSize: "20px", color: "white", letterSpacing:1.5, lineHeight: 1,  height:70}}>Graveyard</div>
        {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "white" }}>Loading... <span style={{paddingLeft:3}}></span><div className="spinner-loader" style={{borderTop:"3px solid #707070"}}></div></div> :
          <div style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%", padding: "50px", width: "100%", height: "100%", maxHeight: "200px", overflow: "scroll" }}>
            {deadFrens.map(dead => {
              return (<div key={dead.name} style={{ padding: "5px" }}>
                <img src={dead.image} alt={`dead`} style={{cursor: "pointer",width:40,height:43, borderRadius:3}} className="img-hover" onClick={() => chosenDead(dead)}/>
              </div>);
            })}
          </div>}
      </div>
      <div style={{ position: "relative", backgroundColor: "#196591", width: "210px", height: "228px", marginTop: "50px", padding: "15px 40px", display: "flex", flexDirection: "column", alignItems: "center", borderRadius:"20px", border:"3px solid black" }}>
        <div style={{ fontSize: "20px", color: "white", letterSpacing:1.5, lineHeight: 1,  height:70 }}>My Frens</div>
        {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "white" }}>Loading... <span style={{paddingLeft:3}}></span><div className="spinner-loader" style={{borderTop:"3px solid #001580"}}></div></div> :
          <div style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%", padding: "50px", width: "100%", height: "100%", maxHeight: "200px", overflow: "scroll" }}>
            {ownedByUser.map(rabbit => {
              return (<div key={rabbit.name} style={{ padding: "5px" }}>
                <img src={rabbit.image} alt={`rabbit`} style={{cursor: "pointer",width:40,height:43, borderRadius:3}} className="img-hover" onClick={() => chosenMyFren(rabbit)}/>
              </div>);
            })}
          </div>}
      </div>

      
      {/* <div style={{ gridColumn: "1 / span 3", position: "relative", backgroundColor: "#196591", width: "710px", height: "228px", marginTop: "50px", padding: "15px 40px", display: "flex", flexDirection: "column", alignItems: "center", borderRadius:"20px", border:"3px solid black" }}>
        <div style={{ fontSize: "20px", color: "white", letterSpacing:1.5, lineHeight: 1,  height:70 }}>My Frens</div>
        {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "white" }}>Loading... <span style={{paddingLeft:3}}></span><div className="spinner-loader" style={{borderTop:"3px solid #001580"}}></div></div> :
      <div style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(10, 1fr)", 
        gridTemplateRows: "repeat(10, 1fr)",
        padding: "50px", 
        width: "100%", 
        height: "100%", 
        maxHeight: "200px", 
        overflow: "scroll" 
      }}>            
      {ownedByUser.map(rabbit => {
              return (<div key={rabbit.name} style={{ padding: "5px" }}>
                <img src={rabbit.image} alt={`rabbit`} style={{cursor: "pointer",width:40,height:43, borderRadius:3}} className="img-hover" onClick={() => chosenMyFren(rabbit)}/>
              </div>);
            })}
          </div>}
      </div> */}

      
      {/* <div style={{ position: "relative", left:"100%", backgroundColor: "#781662", width: "310px", height: "128px", marginTop: "50px", padding: "15px 40px", display: "flex", flexDirection: "column", alignItems: "center", borderRadius:"20px", border:"3px solid black" }}>
        <div style={{ fontSize: "20px", color: "white", letterSpacing:1.5, lineHeight: 1 , height:70}}>All Players</div>
        {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "white" }}>Loading... <span style={{paddingLeft:3}}></span><div className="spinner-loader" style={{borderTop:"3px solid #800000"}}></div></div> :
          <div style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%", padding: "50px", width: "100%", height: "100%", maxHeight: "200px", overflow: "scroll" }}>
            {aliveFrens.map(fren => {
              return (<div key={fren.name} style={{ padding: "5px" }}>
                <img src={fren.image} alt={`fren`} style={{cursor: "pointer",width:40,height:43}} className="img-hover" onClick={() => chosenFren(fren)} />
              </div>);
            })}
          </div>}
      </div> */}

            {/* ************** Players cards section starts here! ************** */}
      {isOpenAllFrenPlayerCard && <div style={{ position: "absolute", bottom: 50, boxShadow: "0 0 25px black", borderRadius: "30px", left: "50%",top:"15%", transform: "translateX(-50%)", backgroundColor: "#eb4444", width: "350px", height: "450px", padding: "40px 25px 55px" }}>
            <div style={{ position: "relative", backgroundColor: "#fffeef", borderRadius: "50px", height: "100%", height: "360px", padding: "60px 20px 10px 20px" }}>
                <div style={{ position: "absolute", top: "-20px", left: "50%", transform: "translateX(-50%)", background: "linear-gradient(90deg, #f54d33, #ba3420)", padding: "10px 20px", fontSize: "22px", borderRadius: "10px",letterSpacing:1.5, lineHeight: 1,  }}>Fren#{selectedAllFren?.name.slice(selectedAllFren?.name.indexOf("#") + 1)}</div>
                    {selectedAllFren && <img style={{borderRadius:15, width:300, height:330}} src={selectedAllFren.image}/> }
                </div>
                {/* <button className="exit-button-myFrens" style={{ position: "absolute", bottom: "6%", left: "26%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => play()}>Play</button>
                <button className="exit-button-myFrens" style={{ position: "absolute", bottom: "6%", left: "50%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => feed()}>Feed</button>
                <button className="exit-button-myFrens" style={{ position: "absolute", bottom: "6%", left: "74%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => clean()}>Clean</button> */}


                <button className="exit-button-player" style={{ position: "absolute", bottom: "-20px", left: "50%", transform: "translateX(-50%)", padding: "10px 20px", fontSize: "20px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => setIsOpenAllFrenPlayerCard(false)}>Close</button>
            </div>}

      {isOpenDeadPlayerCard && <div style={{ position: "absolute", bottom: 50, boxShadow: "0 0 25px black", borderRadius: "30px", left: "50%",top:"15%", transform: "translateX(-50%)", backgroundColor: "#b8baba", width: "350px", height: "450px", padding: "40px 25px 55px" }}>
            <div style={{ position: "relative", backgroundColor: "#fffeef", borderRadius: "50px", height: "100%", height: "360px", padding: "60px 20px 10px 20px"}}>
                <div style={{ position: "absolute", top: "-20px", left: "50%", transform: "translateX(-50%)", background: "linear-gradient(90deg, #a4a6a6, #787878)", padding: "10px 20px", fontSize: "22px", borderRadius: "10px",letterSpacing:1.5, lineHeight: 1,  }}>Fren#{selectedDead?.name.slice(selectedDead?.name.indexOf("#") + 1)}</div>
                    {selectedDead && <img style={{borderRadius:15, width:300, height:330}} src={selectedDead.image}/> }
                </div>
                <button className="exit-button-myFrens" style={{ position: "absolute", bottom: "6%", left: "50%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => revive()}>Revive</button>

                <button className="exit-button-myFrens" style={{ position: "absolute", bottom: "-20px", left: "50%", transform: "translateX(-50%)", padding: "10px 20px", fontSize: "20px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => setIsOpenDeadPlayerCard(false)}>Close</button>
            </div>}

      {isOpenMyFrenPlayerCard && <div style={{ position: "absolute", bottom: 50, boxShadow: "0 0 25px black", borderRadius: "30px", left: "50%",top:"15%", transform: "translateX(-50%)", backgroundColor: "#eb4444", width: "350px", height: "450px", padding: "40px 25px 55px" }}>
            <div style={{ position: "relative", backgroundColor: "#fffeef", borderRadius: "50px", height: "100%", height: "360px", padding: "60px 20px 10px 20px" }}>
                <div style={{ position: "absolute", top: "-20px", left: "50%", transform: "translateX(-50%)", background: "linear-gradient(90deg, #00a1f7, #0058cc)", padding: "10px 20px", fontSize: "22px", borderRadius: "10px",letterSpacing:1.5, lineHeight: 1,  }}>Fren#{selectedMyFren?.name.slice(selectedMyFren?.name.indexOf("#") + 1)}</div>
                    {selectedMyFren && <img style={{borderRadius:15, width:300, height:330}} src={selectedMyFren.image}/> }
                </div>
                <button className="exit-button" style={{ position: "absolute", bottom: "83%", left: "16%", transform: "translateX(-50%)", padding: "5px 5px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => refreshFrenFunc(selectedMyFren)}>↺</button>

                {/* <button className="exit-button" style={{ position: "absolute", bottom: "83%", left: "84%", transform: "translateX(-50%)", padding: "5px 5px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => refreshFrenFunc(selectedMyFren)}>❤️</button> */}

                <button className="exit-button" style={{ position: "absolute", bottom: "6%", left: "26%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => playNow()}>Play</button>
                <button className="exit-button" style={{ position: "absolute", bottom: "6%", left: "50%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => feedNow()}>Feed</button>
                <button className="exit-button" style={{ position: "absolute", bottom: "6%", left: "74%", transform: "translateX(-50%)", padding: "8px 20px", fontSize: "15px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => cleanNow()}>Clean</button>

                <button className="exit-button-player" style={{ position: "absolute", bottom: "-20px", left: "50%", transform: "translateX(-50%)", padding: "10px 20px", fontSize: "20px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => setIsOpenMyFrenPlayerCard(false)}>Close</button>
            </div>}
                {/* ************** Players cards section ends here! ************** */}


</div>

                {/* ************** All 3 section ends here! ************** */}
                {/* ************** New leaderboard starts here! ************** */}
                {/* <div style={{ marginTop: "10px" }}>
        <button className="leaderboard-button" style={{ padding: "20px 50px", color: "#000", fontSize: "20px", border: "none", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  borderRadius:"30px", border:"4px solid black",  }} onClick={() => setIsOpenLeaderBoard(true)}>Leaderboard</button>
        {isOpenLeaderboard && <div style={{ position: "absolute", bottom: 105, boxShadow: "0 0 25px black", borderRadius: "30px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#0184f9", width: "350px", height: "500px", padding: "50px 40px" }}>
          <div style={{ position: "relative", backgroundColor: "#fffeef", borderRadius: "30px", height: "100%", height: "400px", padding: "70px 20px 30px 20px" }}>
            <div style={{ position: "absolute", top: "-20px", left: "50%", transform: "translateX(-50%)", background: "linear-gradient(90deg, #00a1f7, #0058cc)", padding: "10px 20px", fontSize: "22px", borderRadius: "10px",letterSpacing:1.5, lineHeight: 1,  }}>LEADERBOARD</div>
            {loading ? <div style={{ position: "absolute", top: "55%", left: "52%", transform: "translate(-50%, -50%)", color: "black" }}>Loading...  <span style={{paddingLeft:3}}></span><div className="spinner-loader"></div></div> :
            <div style={{ position: "absolute", left:37, top:48, height: "415px", overflow: "scroll", display: "flex", flexDirection: "column", gap: "10px", }}>
              {players.map((player, index) => {
                return <div style={{ background: "linear-gradient(90deg, #02a2fc, #0255c8)", padding: "5px 20px", borderRadius: "10px", display: "flex", justifyContent: "center"}}>
                  <span style={{ fontSize: "22px", color: index == 0 ? "gold" : index == 1 ? "silver" : index==2 ? "#cd7f32" : "white" , textShadow: "2px 2px 1px black", letterSpacing:1.5, lineHeight: 1,  marginRight:"7px"}}>{`${index + 1} `+" "}</span>
                  <span style={{ fontSize: "18px", letterSpacing:1.5, lineHeight: 1,  marginRight:"4px", paddingTop:"3px" , color: player[1] == "MyFren" ?"blue" : "red"}}>{"|"}</span>
                  <span style={{ fontSize: "16px", letterSpacing:1.5, lineHeight: 1,  marginRight:"5px", paddingTop:"3px" }}>{player[1]}</span>
                  <span style={{ fontSize: "16px", letterSpacing:1.5, lineHeight: 1,  marginRight:"4px", paddingTop:"2px" }}>{player.name.substring(19)}</span>
                  <span style={{ fontSize: "10px", padding: "0 7px", letterSpacing:1.5, lineHeight: 1,  paddingTop:"2px"}}>{"with: "+player.happiness-1+" happiness |"+player.energy-1+" energy |"+player.cleanliness-1+" cleanliness |"}</span>
                </div>
              })}
            </div>
          }
            <button className="exit-button" style={{ position: "absolute", bottom: "-20px", left: "50%", transform: "translateX(-50%)", padding: "10px 20px", fontSize: "20px", borderRadius: "10px", outline: "none", border: "none", color: "#fff", cursor: "pointer", letterSpacing:1.5, lineHeight: 1,  }} onClick={() => setIsOpenLeaderBoard(false)}>EXIT</button>
          </div>
        </div>}
      </div> */}
      
            {/* ************** New leaderboard ends here! ************** */}
  

            {/* ************** Explore Map section starts here! ************** */}

            <div style={{marginTop:35, position:"absolute", bottom:20}} >
                <button style={{fontSize:20, letterSpacing:1.5, lineHeight: 1, }} class="glow-on-hover" type="button"  onClick={() => alert({ message: 'Coming Soon! Follow updates on the website and discord to stay up to date!', type: 'success' })}>Explore Map</button>   
            </div>

            {/* ************** Explore Map section ends here! ************** */}

    </div>
    
  );
}

export default Arena;
